import { render } from "./DeleteProductDialog.vue?vue&type=template&id=712960f2&scoped=true"
import script from "./DeleteProductDialog.vue?vue&type=script&lang=js"
export * from "./DeleteProductDialog.vue?vue&type=script&lang=js"

import "./DeleteProductDialog.vue?vue&type=style&index=0&id=712960f2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712960f2"]])

export default __exports__